var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({backgroundColor: _vm.$store.state.backgroundColor}),attrs:{"id":"exhibitionMenus"}},[_c('FloatingMenu'),_c('ExhibitionMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }